const FAQS = [
  {
    q: '香蕉漫画需要注册才能阅读吗？',
    a: '不需要。香蕉漫画所有内容完全免费开放，无需注册或登录即可直接在线阅读全部漫画，包括热门韩漫、日漫、国漫的全集完整版，打开即看。',
  },
  {
    q: '漫画支持哪些设备阅读？',
    a: '香蕉漫画采用响应式网页设计，完美适配电脑、平板和手机端。推荐在手机上使用下拉式阅读模式，流畅翻页体验更佳，随时随地畅享高清漫画。',
  },
  {
    q: '漫画多久更新一次？',
    a: '编辑团队每日跟踪各大漫画平台连载进度，热门韩漫和日漫作品通常每周更新1-2话，国漫连载频率因作品而异。首页"最新动态"模块可查看最近更新的漫画列表。',
  },
  {
    q: '可以下载漫画离线阅读吗？',
    a: '香蕉漫画目前为在线漫画阅读平台，不支持离线下载功能。建议在有网络连接的环境下阅读，移动端阅读体验已优化至最佳状态，流量消耗较低。',
  },
  {
    q: '如何快速找到想看的漫画？',
    a: '你可以通过首页"漫画分类"模块按类型浏览，或查看"人气排行"了解当前热门作品。首页"热门话题"区域也展示了当下最受关注的漫画标签，点击即可发现相关推荐。',
  },
  {
    q: '推荐的漫画都是正版吗？',
    a: '香蕉漫画作为漫画推荐与索引平台，致力于为漫迷提供高质量的漫画发现服务。我们精选全网热门资源，帮助读者快速定位感兴趣的作品，倡导支持正版漫画。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            关于香蕉漫画的使用与功能，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {FAQS.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <div className="px-5 md:px-6 py-4 md:py-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {faq.q}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-7">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}